<template>
    <router-view />
    <jl-alert />
    <DeleteModal />
    <AddTopicModal />
</template>

<script>
import DeleteModal from './views/modal/DeleteModal';
import AddTopicModal from './views/modal/AddTopicModal';

export default {
  components: {
      DeleteModal,
      AddTopicModal
  },
  mounted() {
  },
  watch: {
      
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400;500;600;700;800;900&display=swap');

@font-face {
  font-family: 'Versatech Font';
  src: url(./assets/versatech_font.otf);
}

:root {
    --primary-color: #6696e8;
    --sub-color: #6dcef5;
    --gray-color: #999999;
    --dark-color: #333333;
}

/* *,*::before,*::after {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
} */

.bg-gray {
  background-color: #48494A !important;
}

html, body, #app {
    width: 100%;
    height: 100%;
}

#app {
    display: flex;
    flex-direction: column;
    font-family: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important; /*'Versatech Font';*/
    color: #2c3e50;
}

html, body {
    font-size: 14px;
    color: #828282 !important;
}

p {
    margin-bottom: 0 !important;
}

a {
  text-decoration: none !important;
}

.fs-8 {
  font-size: 8px !important;
}.fs-9 {
  font-size: 9px !important;
}.fs-10 {
  font-size: 10px !important;
}.fs-11 {
  font-size: 11px !important;
}.fs-12 {
  font-size: 12px !important;
}.fs-13 {
  font-size: 13px !important;
}.fs-14 {
  font-size: 14px !important;
}.fs-15 {
  font-size: 15px !important;
}.fs-16 {
  font-size: 16px !important;
}.fs-17 {
  font-size: 17px !important;
}.fs-18 {
  font-size: 18px !important;
}.fs-19 {
  font-size: 19px !important;
}.fs-20 {
  font-size: 20px !important;
}.fs-21 {
  font-size: 21px !important;
}.fs-22 {
  font-size: 22px !important;
}.fs-23 {
  font-size: 23px !important;
}.fs-24 {
  font-size: 24px !important;
}

.fw-400 {
  font-weight: 400 !important;
}.fw-500 {
  font-weight: 500 !important;
}.fw-600 {
  font-weight: 600 !important;
}.fw-700 {
  font-weight: 700 !important;
}.fw-800 {
  font-weight: 800 !important;
}.fw-900 {
  font-weight: 900 !important;
}

.opacity-1 {
  opacity: 0.1;
}.opacity-2 {
  opacity: 0.2;
}.opacity-3 {
  opacity: 0.3;
}.opacity-4 {
  opacity: 0.4;
}.opacity-5 {
  opacity: 0.5;
}.opacity-6 {
  opacity: 0.6;
}.opacity-7 {
  opacity: 0.7;
}.opacity-8 {
  opacity: 0.8;
}.opacity-9 {
  opacity: 0.9;
}

.flex-0 {
    flex: 0 !important;
}
.flex-1 {
    flex: 1 !important;
}

input::placeholder {
    opacity: 0.4;
}

button, button:active, button:focus,.btn-check:active+.btn-primary:focus, .btn-check:checked+.btn-primary:focus, .btn-primary.active:focus, .btn-primary:active:focus, .show>.btn-primary.dropdown-toggle:focus, .btn-check:focus+.btn-primary, .btn-primary:focus, input.custom-input:focus, input.custom-input:active,.btn-check:focus+.btn, .btn:focus, select:focus {
  box-shadow: none !important;
  outline: none !important;
}

@media screen and (max-width: 991px) {
    *,*::before,*::after {
      -webkit-tap-highlight-color: transparent;
      -webkit-user-select: none;
      -webkit-touch-callout: none;
      -webkit-overflow-scrolling: auto;
    }
    *::-webkit-scrollbar {
      width: 0px;
    }
}

.custom-input {
    border: 0 !important;
    background: #f9f9f9 !important;
    transition: 0.3s !important;
    color: #757575 !important;
    font-weight: 600 !important;
}

.custom-input:focus, .custom-input:hover {
    background: #f3f3f3 !important;
}

.custom-input.error {
  border: 1px solid red !important;
}

.custom-input:disabled, .custom-input.disabled, .custom-input[disabled] {
    cursor: not-allowed;
    opacity: 0.5 !important;
}

.cp {
   cursor: pointer;
}

.form-group {
  margin-bottom: 10px;
}

.btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:focus {
  background-color: var(--primary-color) !important;
  border: 0 !important;
}

.mdi {
  height: 0;
}


.modal-header {
  background-color: var(--primary-color);
  border-bottom: none;
}

.modal-header .modal-title {
    color: #fff;
}

.modal-header .close {
    margin: 0;
    background: rgba(255, 255, 255, 0.25);
    text-shadow: none;
    padding: 0;
    color: #fff;
    opacity: 1;
    border-radius: 50%;
    padding: 0 4px;
}

.modal-header .close:hover {
  color: rgb(223, 223, 223);
}

.modal-footer {
    padding: 0.75rem 1.5rem;
    background: #e9ecef;
    border-radius: 0 0 0.25rem 0.25rem;
}

.modal-footer button {
    color: #6c757d;
    font-weight: 700;
}

.ql-editor {
    font-size: 14px !important;
}

.btn-default:hover {
    background: #00000008;
}

.btn-rounded {
    border-radius: 50% !important;
}

.bg {
    background-color: #00000005;
}

/* ::-webkit-scrollbar-track
{
	-webkit-box-shadow: transparent;
	border-radius: 10px;
	background-color: transparent;
}

::-webkit-scrollbar
{
	width: 10px;
  margin-right: 5px;
	background-color: transparent;
}

::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: transparent;
	background-color: rgb(45 45 45 / 41%)
} */

::-webkit-scrollbar {
    width: 15px;
    height: 18px;
}
::-webkit-scrollbar-thumb {
    height: 6px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    -webkit-border-radius: 7px;
    background-color: rgb(0 0 0 / 28%);
    -webkit-box-shadow: transparent;
}
::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
}
::-webkit-scrollbar-corner {
    background-color: transparent;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.ellipsis-2 {
    display: block;
    display: -webkit-box;
    white-space: break-spaces;
    max-width: 100%;
    min-height: 38px;
    margin: 0 0;
    font-size: 14px;
    line-height: 1.4;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.modal-title {
  font-size: 16px;
}

.shimmer {
  width: 100%;
  height: 100%;
  border-radius: 5px;

  /* the shimmer magic */
  animation : shimmer 2s infinite;
  background: linear-gradient(to right, #f9f9f9 4%, #e6e6e6 25%, #f9f9f9 36%);

  background-size: 1000px 100%;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.quillWrapper {
    width: 100%;
    height: 100%;
    display: inline-flex;
    flex-direction: column;
}

.ql-pdf::before {
    display: inline-block;
    font: normal normal normal 24px/1 "Material Design Icons";
    font-size: 22px;
    text-rendering: auto;
    line-height: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\F0E2D";
    height: 0;
    margin-top: -5px;
}

.ql-img::before {
    display: inline-block;
    font: normal normal normal 24px/1 "Material Design Icons";
    font-size: 22px;
    text-rendering: auto;
    line-height: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\F0EB0";
    height: 0;
    margin-top: -5px;
}

.ql-video {
  width: 100%;
  height: 100%;
}

.ql-img, .ql-image {
  width: 100%;
  max-width: 100%;
}

.form-select {
  padding: .375rem 3rem .375rem .75rem;
}

.sortable th:hover {
  color: var(--primary-color);
  cursor: pointer;
}

.card {
    border: 1px solid #0000001a !important;
}

input::placeholder {
  text-transform: capitalize;
}

.tag-input {
  width: 100%;
  border: 1px solid #eee;
  font-size: 0.9em;
  height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
}

.tag-input__tag {
  height: 30px;
  float: left;
  margin-right: 10px;
  background-color: #eee;
  margin-top: 10px;
  line-height: 30px;
  padding: 0 5px;
  border-radius: 5px;
}

.tag-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}

.tag-input__text {
  border: none;
  outline: none;
  font-size: 0.9em;
  line-height: 50px;
  background: none;
}

.WordSection1 * {
  text-align: left !important;
}

img {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  pointer-events: none;
  cursor: not-allowed;
  -webkit-user-drag: none; 
  -khtml-user-drag: none; 
  -moz-user-drag: none; 
  -o-user-drag: none; 
  user-drag: none; 
}


footer {
  background-color: #F8F9FA;
}
.logo-mis::before {
  content: 'LAMCO ';
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 800;
  color: #000;
}
.logo-mis::after {
  content: '';
  width: 45px;
  height: 18px;
  background: url(./assets/mislogo.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: 5px;
}

.logo-mis {
    opacity: 0.4;
    display: flex;
    flex-direction: row;
}
.love::after {
  content: '❤️';
  margin-left: 5px;
  margin-right: 5px;
  position: relative;
  font-size: 15px;
}

.ql-cursor {
  display: none !important;
}
</style>
